import type { OrchestrationThreadActivity } from "@afar-research/contracts";

function activityLifecycleRank(kind: string): number {
  if (kind.endsWith(".started") || kind === "tool.started") return 0;
  if (kind.endsWith(".progress") || kind.endsWith(".updated")) return 1;
  if (kind.endsWith(".completed") || kind.endsWith(".resolved")) return 2;
  return 1;
}

/** Stable ordering for persisted orchestration activities and replayed stream events. */
export function compareOrchestrationActivitiesByOrder(
  left: OrchestrationThreadActivity,
  right: OrchestrationThreadActivity,
): number {
  if (left.sequence !== undefined && right.sequence !== undefined) {
    const sequenceComparison = left.sequence - right.sequence;
    if (sequenceComparison !== 0) return sequenceComparison;
  } else if (left.sequence !== undefined) {
    return 1;
  } else if (right.sequence !== undefined) {
    return -1;
  }

  return (
    left.createdAt.localeCompare(right.createdAt) ||
    activityLifecycleRank(left.kind) - activityLifecycleRank(right.kind) ||
    left.id.localeCompare(right.id)
  );
}
